export const checkIfUrlStartsWithProtocol = (url:any) => {

    if(url.indexOf('https://') === 0 || url.indexOf('http://') === 0){
        return true;
    }else{
        return false;
    }
};